import "./src/utils/globals.css"
require('typeface-nunito');